import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Col, Row, Table, Grid, Divider, Button } from "antd";
import { PageName, SearchContainer, SearchIcon, SearchInput, SearchButton, StyledCard } from './style';
import { MyText } from "../../components";
import {useTranslation} from "react-i18next";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import { fetchListRequestAction, RootState, selectStore } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
interface Specialist {
  id: number;
  name: string;
  description?: string;
}

const isMobile = window.innerWidth < 768;

export const MyConsultations = () => {
  const {t} = useTranslation("common")

  const [searchParams, setSearchParams] = useSearchParams();
  const [kindergartens, setKindergartens] = useState<any[]>([]);
  // const [listRequest, setListRequest] = useState<any[]>([]);
  const { profile: { specialistsData: specialistsState}}: RootState = useSelector(selectStore); 
  const listRequestState = useSelector((state: any) => state.materials?.listRequest ?? { data: null, loading: false });
  const listRequest = listRequestState.data?.items || [];
  const loading = listRequestState.loading;

  const specialists = Array.isArray(specialistsState?.data)
  ? specialistsState.data
  : [];
  // const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState('');
  const segmentedParams: any = searchParams.get('type');
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();


  // useEffect(() => {
  //       const fetchListRequestData = async () => {
  //           try {
  //               const response = await fetchListRequest();
  //               setListRequest(response?.items);
  //               setLoading(false);

  //           } catch (error) {
  //               console.error('Ошибка при получении специалистов', error);
  //               setLoading(false);

  //           }
  //       };
  //       fetchListRequestData();
  //   }, []);

  useEffect(() => {
    dispatch(fetchListRequestAction());
  }, []);

  const dataSource = listRequest.map((item) => {
  const specialistObj = specialists.find(s => s.id === item.specialist_type);

  return {
    key: item.id,
    number: item.id,
    name: item.name,
    address: item.problem_text,
    specialist: specialistObj ? specialistObj.name : '',
    phones: dayjs(item.created_at).format("DD.MM.YYYY HH:mm"),
    consultationPoint: (
      <Button
        style={{
          borderRadius: 12,
          height: 48,
          background: item.answer ? "rgba(231, 250, 255, 1)" : "rgba(255, 249, 238, 1)",
          border: 'none'
        }}
        onClick={() => {
          if (item.answer) {
           embeddedNavigate(`/results/consultation/testId/${item.id}/type/1`);
          }
        }}
      >
        <MyText
          color={item.answer ? "rgba(0, 141, 210, 1)" : "rgba(205, 97, 21, 1)"}
          weight={600}
        >
          {item.answer ? t("view") : t("underReview")}
        </MyText>
      </Button>
    ),
  };
});

  const columns = [
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{`${t("applicationNumber")}`}</span>,
      dataIndex: 'number',
      key: 'number',
      width: '5%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("name")}</span>,
      dataIndex: 'name',
      key: 'name',
      width: '18%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("ask")}</span>,
      dataIndex: 'address',
      key: 'address',
      width: '20%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("specialist")}</span>,
      dataIndex: 'specialist',
      key: 'specialist',
      width: '10%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("submissionDate")}</span>,
      dataIndex: 'phones',
      key: 'phones',
      width: '10%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("answer")}</span>,
      dataIndex: 'consultationPoint',
      key: 'consultationPoint',
      width: '10%',
    },
  ];

  return (
    <Row justify='center'>
      <Col span={20}>
        <Row gutter={[32, 32]}>
            <Col span={24}>
            <MyText color='#0A033C' size={40} weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block' }}>
            {t("myConsultations")}
            </MyText>
          </Col>

          <Col span={24}>
            <StyledCard>
            <Row style={{ padding: screens.xs ? 16 : 32 }}>
            <Col style={{ maxWidth: '100%', wordWrap: 'break-word' }}>
                <MyText
                color="rgba(19, 15, 38, 1)"
                size={screens.xs ? 16 : 24}
                weight={400}
                style={{ fontFamily: 'Nunito', lineHeight: screens.xs ? '18px' : '32px', textAlign: 'justify' }}
                >
                {t("allRequestsDescription")}
                </MyText>
            </Col>
            </Row>
            </StyledCard>
          </Col>

          <Col span={24}>
            <StyledCard>
              {!screens.xs && (
                <Table dataSource={dataSource} columns={columns} pagination={false} loading={loading} locale={{ emptyText: t('noData') }}/>
                )}
                </StyledCard>

               {screens.xs && listRequest.map((item) => {
            const specialistObj = specialists.find((s: Specialist) => s.id === item.specialist_type);

            return (
              <StyledCard key={item.id} style={{ marginTop: 12 }}>
                <Col style={{ marginTop: 16 }}>
                  <MyText size={16} weight={800} style={{ fontFamily: 'Nunito' }}>
                    {`${t("applicationNumber")}`}: {item.id}
                  </MyText>
                </Col>
                <Col>
                  <MyText size={14} weight={600} style={{ fontFamily: 'Nunito' }}>
                    {`${t("name")}`}: {item.name}
                  </MyText>
                </Col>
                <Col>
                  <MyText size={14} weight={600} style={{ fontFamily: 'Nunito' }}>
                    {`${t("ask")}`}: {item.problem_text}
                  </MyText>
                </Col>
                <Col>
                  <MyText size={14} weight={600} style={{ fontFamily: 'Nunito' }}>
                    {`${t("specialist")}`}: {specialistObj ? specialistObj.name : 'Неизвестно'}
                  </MyText>
                </Col>
                <Col>
                  <MyText size={14} weight={600} style={{ fontFamily: 'Nunito' }}>
                    {`${t("submissionDate")}`}: {dayjs(item.created_at).format("DD.MM.YYYY HH:mm")}
                  </MyText>
                </Col>
                <Divider style={{ marginTop: 16, marginBottom: 12 }} />
                <Col span={24} style={{ marginTop: 12, marginBottom: 12 }}>
                  <Button
                    style={{
                      borderRadius: 12,
                      height: 48,
                      background: item.answer ? "rgba(231, 250, 255, 1)" : "rgba(255, 249, 238, 1)",
                      border: 'none'
                    }}
                    onClick={() => {
                      if (item.answer) {
                      embeddedNavigate(`/results/consultation/testId/${item.id}/type/1`);
                      }
                    }}
                  >
                    <MyText
                      color={item.answer ? "rgba(0, 141, 210, 1)" : "rgba(205, 97, 21, 1)"}
                      weight={600}
                    >
                      {item.answer ? `${t("view")}` : `${t("underReview")}`}
                    </MyText>
                  </Button>
                </Col>
              </StyledCard>
            );
          })}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
